import { useMemo } from "react";
import { usePermissions } from "./usePermissions";
import { scopeCustomers } from "../../functions/permissions";
import { useWebshopUsers } from "./useUsers";

/**
 * De webshopklanten (useWebshopUsers) beperkt tot de scope van de
 * ingelogde gebruiker: landen, een klantselectie, of alles. Zonder beperking
 * is dit exact dezelfde array als in de store. Gebruik dit in plaats van
 * `useWebshopUsers()` rechtstreeks waar klanten getoond worden.
 */
export const useScopedCustomers = () => {
  const allUsers = useWebshopUsers();
  const { scope } = usePermissions();
  return useMemo(() => scopeCustomers(allUsers, scope), [allUsers, scope]);
};

export default useScopedCustomers;
